import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { ProjectGq, ProjectGqProps } from '../models/ProjectGq';

export function useGetProjectGq(
  command: Command,
  options?: QueryHookOptions<GQLData, GQLVariables>
) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command },
    ...options,
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getProject?.project,
  };
}

const gqTag = gql`
  query GetProject($command: GetProjectCommand!) {
    projects {
      getProject(command: $command) {
        project {
          ${ProjectGqProps}
        }
      }
    }
  }
`;

interface GQLData {
  readonly projects: {
    readonly getProject: {
      readonly project: ProjectGq;
    };
  };
}

export interface GQLVariables {
  command: Command;
}

export interface Command {
  id?: number;
  tagImportProject?: boolean;
}
